import { Heading } from 'components/ui/Heading/Heading';
import { ReactComponent as ErrorIcon } from 'icons/error.svg';
import PropTypes from 'prop-types';
import { useTranslations } from 'utils';
import './MissingInstructionsError.scss';

function MissingInstructionsError({ instructionsErrors }) {
  const i18n = useTranslations();

  const errorDescription = instructionsErrors
    ?.map(error =>
      i18n.t(`statusContent.missingInstructions.description.error_${error}`),
    )
    .join('\n');
  return (
    <div
      className={
        'textAlign-center paddingBottom-xxxxl marginLeft-md marginRight-md'
      }
      data-testid="missingInstructions"
    >
      <ErrorIcon className="marginBottom-lg marginTop-xxxxl" />
      <Heading
        as="h1"
        size="large"
        className="textAlign-center marginBotom-sm fontWeight-semiBold marginBottom-sm"
      >
        {i18n.t('checkout.missingInstructions.title')}
      </Heading>
      <p className="type-medium paddingH-xl MissingInstructions-errorDescription">
        {errorDescription ?? i18n.t('checkout.missingInstructions.description')}
      </p>
    </div>
  );
}

MissingInstructionsError.displayName = 'MissingInstructionsError';

MissingInstructionsError.propTypes = {
  instructionsErrors: PropTypes.arrayOf(PropTypes.string),
};

export { MissingInstructionsError };
